import React from 'react';
import SpreadReadingPage from './SpreadReadingPage';

const config = {
  pickerPage: 'daily',
  path: '/daily-tarot-reading/',
  spreadId: 'dailyReading',
  cardCount: 1,
  metaTitle: 'Free Daily Tarot Reading - Pick Your Card for Today | NowTarot AI',
  metaDescription:
    'Get a free daily tarot reading. Shuffle the deck and pick one card to reveal the energy and guidance for your day ahead. 100% free, no signup required.',
  metaKeywords:
    'daily tarot reading, free daily tarot, daily tarot card, tarot reading for today, one card daily tarot, daily tarot pull',
  heading: 'Daily Tarot Reading',
  intro:
    'Start your day with a single card. This free daily tarot reading lets you shuffle the full 78-card deck and pick the card that reveals the energy shaping your day, along with practical guidance for the hours ahead. 100% free, no signup required.',
  howItWorks:
    'Take a breath and think about the day in front of you, or a specific situation you will face today. Shuffle the deck, then pick one card. Your card describes the main energy around you today and how to work with it.',
  contentSections: [
    {
      heading: 'How to Use Your Daily Card',
      items: [
        {
          title: 'Set an Intention',
          text: 'Before you draw, ask a simple question such as "What do I need to know today?" or "What energy should I bring into this meeting?" A focused question makes the card easier to apply.',
        },
        {
          title: 'Look for It During the Day',
          text: "Keep your card in mind as the day unfolds. Many people notice the card's theme in a conversation, a decision, or a feeling they would otherwise have brushed past.",
        },
        {
          title: 'Reflect in the Evening',
          text: 'At night, look back at the card and ask how it showed up. Keeping a short tarot journal turns daily pulls into a fast way to learn every card in the deck.',
        },
      ],
    },
    {
      heading: 'Common Daily Tarot Cards and What They Suggest',
      items: [
        {
          title: 'The Sun & Three of Wands',
          text: 'Bright, outward energy. Expect momentum, good news, or a reason to be optimistic. A good day to start something or to put yourself forward.',
        },
        {
          title: 'Four of Swords & The Hermit',
          text: 'A signal to slow down. These cards ask for rest, quiet focus, or time alone before you make a big move.',
        },
        {
          title: 'Five of Wands & Seven of Swords',
          text: 'Friction or mixed motives may surface. Pick your battles, communicate clearly, and double-check details before you commit.',
        },
      ],
    },
  ],
  faqHeading: 'Daily Tarot FAQ',
  faq: [
    {
      question: 'How does a daily tarot reading work?',
      answer:
        'You focus on the day ahead, shuffle the deck, and pick one card from the 78-card tarot deck. That single card describes the main energy influencing your day and offers guidance for how to approach it.',
    },
    {
      question: 'Should I pull a tarot card every day?',
      answer:
        'A daily pull is one of the best ways to build a tarot habit. It takes a minute, keeps you reflective, and helps you learn the cards quickly. One card per day is enough; redrawing for a better card dilutes the message.',
    },
    {
      question: 'How is this different from the Card of the Day?',
      answer:
        'Card of the Day is a one-card pull about that card’s meaning. This daily reading is about how to work with the card through the hours ahead. On both pages you shuffle and pick your own card.',
    },
    {
      question: 'Is this daily tarot reading free?',
      answer:
        'Yes! This daily tarot reading is 100% free with no signup or credit card required. For deeper, personalized guidance, ask our AI tarot reader in chat.',
    },
  ],
  crossLinks: (
    <>
      Want more? Draw a <a href="/card-of-the-day/" style={{ color: '#FFD700' }}>tarot card of the day</a>, ask a{' '}
      <a href="/yes-or-no-tarot/" style={{ color: '#FFD700' }}>yes or no tarot</a> question, or try a{' '}
      <a href="/three-card-tarot/" style={{ color: '#FFD700' }}>3-card past, present, future</a> reading — all free, no signup required.
    </>
  ),
};

const DailyTarot = () => <SpreadReadingPage config={config} />;

export default DailyTarot;
